import { lazy } from "react";

const BatchList = lazy(() => import("./BatchList"));

export default {
  list: BatchList,
};
